module.exports = {
    handyHint: {
        edrPassword: 'Please enter the same password you use to access your Woolworths Reward card account on www.woolworthsrewards.com.au',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/handy-hint.js